import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class VerticalAxisTick extends React.PureComponent<any> {
  // eslint-disable-next-line
  render() {
    const anyProps = this.props;
    return (
      <g>
        <text
          x={anyProps.x}
          y={anyProps.y}
          dy={17}
          dx={-15}
          textAnchor="end"
          fill="#666"
          style={{
            transform: 'translate(0px, -12px)',
            marginRight: '40px',
            fontSize: 10,
          }}
          className="MuiTypography-root MuiTypography-body2 MuiTypography-colorTextSecondary"
        >
          {this.props.payload.value}
        </text>
      </g>
    );
  }
}
